import { AreaDetail, AreaDetailWithData, Legend } from "@models/map";

export class StateMapResponse {
    public areaDetails: AreaDetail[];
    public legend: Legend;
}

export class MapResponseWithData {
    public areaDetails: AreaDetailWithData[];
    public legend: Legend;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/state-map-response.ts